/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Route configuration for calls detail
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.4.0
 */

import { EBasketType } from '../../modules/app/appConstants';
import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { IAppRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export interface ICallsDetailRouteConfiguration extends IAppRouterConfiguration {
    basketType: EBasketType;
}

export const CallsDetailRouteConfiguration: ICallsDetailRouteConfiguration[] = [
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailMobile,
    },
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.subscriberMobileInfo,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailMobileInfo,
    },
    {
        basketType: EBasketType.FIXED,
        breadCrumbs: [
            EBreadCrumbType.subscriberFixed,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailFixed,
    },
    {
        basketType: EBasketType.FIXED,
        breadCrumbs: [
            EBreadCrumbType.subscriberFixed,
            EBreadCrumbType.subscriberFixedInfo,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailFixedInfo,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.expensesAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesAccounts,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.expensesAccounts,
            EBreadCrumbType.expensesAccountsSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesAccountsSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.expensesAccountId,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesAccountId,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.expensesAccountId,
            EBreadCrumbType.expensesAccountIdSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesAccountIdSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.expensesAccountId,
            EBreadCrumbType.expensesAccountIdSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesAccountIdSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.bills,
            EBreadCrumbType.expensesBillsAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesBillsAccounts,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.bills,
            EBreadCrumbType.expensesBillsAccounts,
            EBreadCrumbType.expensesBillsAccountsSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesBillsAccountsSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsAccountId,
            EBreadCrumbType.expensesBillsAccountId,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesBillsAccountId,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsAccountId,
            EBreadCrumbType.expensesBillsAccountId,
            EBreadCrumbType.expensesBillsAccountIdSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesBillsAccountIdSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.billsUnpaid,
            EBreadCrumbType.expensesBillsUnpaidAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesBillsUnpaidAccounts,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.billsUnpaid,
            EBreadCrumbType.expensesBillsUnpaidAccounts,
            EBreadCrumbType.expensesBillsUnpaidAccountsSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesBillsUnpaidAccountsSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsUnpaidAccountId,
            EBreadCrumbType.expensesBillsUnpaidAccountId,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesBillsUnpaidAccountId,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsUnpaidAccountId,
            EBreadCrumbType.expensesBillsUnpaidAccountId,
            EBreadCrumbType.expensesBillsUnpaidAccountIdSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesBillsUnpaidAccountIdSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [
            EBreadCrumbType.subscriberFixed,
            EBreadCrumbType.expensesSubscriberFixed,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesSubscriberFixed,
    },
    {
        basketType: EBasketType.EXPENSES_SUBSCRIBERS,
        breadCrumbs: [EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.expensesSubscriberMobile,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailExpensesSubscriberMobile,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.expensesAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesAccount,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.expensesAccounts,
            EBreadCrumbType.expensesAccountsSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesAccountSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.expensesAccountId,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesAccountSingle,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.expensesAccountId,
            EBreadCrumbType.expensesAccountIdSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesAccountSingleSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.expensesSubscriberMobile,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesSubscriberMobile,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.bills,
            EBreadCrumbType.expensesBillsAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsAccount,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsAccountId,
            EBreadCrumbType.expensesBillsAccountId,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsAccountSingle,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsAccountId,
            EBreadCrumbType.expensesBillsAccountId,
            EBreadCrumbType.expensesBillsAccountIdSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsAccountSingleSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.bills,
            EBreadCrumbType.expensesBillsAccounts,
            EBreadCrumbType.expensesBillsAccountsSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsAccountsSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.billsUnpaid,
            EBreadCrumbType.expensesBillsUnpaidAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsUnpaidAccount,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsUnpaidAccountId,
            EBreadCrumbType.expensesBillsUnpaidAccountId,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsUnpaidAccountSingle,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsUnpaidAccountId,
            EBreadCrumbType.expensesBillsUnpaidAccountId,
            EBreadCrumbType.expensesBillsUnpaidAccountIdSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsUnpaidAccountSingleSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.billsUnpaid,
            EBreadCrumbType.expensesBillsUnpaidAccounts,
            EBreadCrumbType.expensesBillsUnpaidAccountsSubscribers,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsUnpaidAccountsSubscribers,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.expensesAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesAccountId,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.bills,
            EBreadCrumbType.expensesBillsAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsAccountId,
    },
    {
        basketType: EBasketType.EXPENSES,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.billsUnpaid,
            EBreadCrumbType.expensesBillsUnpaidAccounts,
            EBreadCrumbType.callsDetail,
        ],
        path: RoutePath.callsDetailDailyExpensesBillsUnpaidAccountId,
    },
];
